module.exports = __webpack_public_path__ + "img/0Q3B1621-26_H_L_Black.a9a66738.jpg";